<template>
  <section class="container" v-if="isReedy">
    <div class="learning-page">
      <div class="learning-page__container">
        <!-- 課程影片區 -->
        <div class="learning-page__video-wrapper">
          <div class="learning-video">
            <div class="learning-video__player" :style="`--content:'${cssContent}'`">
              <div
                class="learning-video__container"
                :style="{
                  backgroundImage: 'url(' + data.contentImagePath + ')',
                }"
              >
                <div class="learning-video__iframe" v-show="hasVideo">
                  <video id="player" playsinline controls></video>
                </div>
              </div>
            </div>
          </div>

          <div class="learning-page__notice">
            <i18n path="learning.question.playbackIssue" tag="p" class="learning-page__notice-text">
              <router-link place="faqLink" to="/novices/question">
                {{ $t('route.title.question') }}
              </router-link>
            </i18n>
          </div>
        </div>

        <!-- 課程列表側邊欄 -->
        <div class="learning-page__sidebar">
          <div class="learning-sidebar">
            <div class="learning-sidebar__header">
              <h5 class="learning-sidebar__title">{{ data.courseName }}</h5>
            </div>

          <div class="learning-sidebar__tabs">
            <button
              class="learning-sidebar__tab"
              :class="{ 'learning-sidebar__tab--active': courseType === 1 }"
              @click.prevent="courseType = 1"
            >
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>{{ $t('learning.allCourses') }}</span>
            </button>
            <button
              class="learning-sidebar__tab"
              :class="{ 'learning-sidebar__tab--active': courseType === 2 }"
              @click.prevent="courseType = 2"
            >
              <i class="fa fa-heart" aria-hidden="true"></i>
              <span>{{ $t('learning.favorites') }}</span>
            </button>
          </div>

          <ul
            class="learning-sidebar__list"
            :class="{'learning-sidebar__list--has-link': subject.otherLinkPath}"
          >
            <template v-if="courseData.length">
              <li
                class="learning-course"
                :class="{ 'active': index === 0 }"
                v-for="(item, index) in courseData"
                :key="`${index}-${item.subjectId}`"
              >
                <div class="learning-course__header" @click="ToggleClass($event)">
                  <div class="learning-course__header-info">
                    <i class="fa fa-th" aria-hidden="true"></i>
                    <span>{{ item.groupName }}</span>
                  </div>
                  <div class="learning-course__header-count">
                    {{ item.buyCourseClassRoomList.length }} {{ $t('course.unit.lessons') }}
                  </div>
                  <div class="learning-course__header-toggle">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                  </div>
                </div>

                <ul class="learning-course__lessons">
                  <li
                    class="learning-lesson"
                    :class="{
                      'learning-lesson--playing': item2.classCode === currentPlay.classCode,
                      'learning-lesson--coming-soon': item2.hasVideo === false
                    }"
                    v-for="(item2, index2) in item.buyCourseClassRoomList"
                    :key="`${index2}-${item2.classId}`"
                  >
                    <i
                      class="fa fa-play-circle learning-lesson__play-icon"
                      aria-hidden="true"
                      v-if="item2.classCode === currentPlay.classCode"
                    ></i>
                    <a
                      href="#"
                      class="learning-lesson__link"
                      @click.prevent="OpenVideo(item2)"
                    >
                      {{ item2.className }}({{ item2.teacherName }})
                    </a>
                    <div class="learning-lesson__info">
                      <div class="learning-lesson__status-icon">
                        <i
                          class="fa fa-check-circle"
                          :class="{ 'learning-lesson__status-icon--completed': item2.isLook }"
                        ></i>
                      </div>
                      <div
                        class="learning-lesson__time"
                        :class="{ 'learning-lesson__time--disabled': !item2.hasVideo }"
                      >
                        {{ $t('learning.viewRecord') }}: ({{ item2.time | secConvertTime }})
                      </div>
                      <div class="learning-lesson__notes">
                        <a
                          href="#"
                          class="learning-lesson__notes-link"
                          :class="{ 'learning-lesson__notes-link--disabled': !item2.hasVideo }"
                          @click.prevent="
                            () => {
                              if (item2.hasVideo === true) handleOpenNode(item2);
                            }
                          "
                        >
                          {{ $t('learning.notes') }}({{ item2.videoNotesCount }})
                        </a>
                      </div>
                      <div class="learning-lesson__favorite">
                        <a
                          href="#"
                          class="learning-lesson__favorite-btn"
                          @click.prevent="handleFavorite(item2)"
                        >
                          <i
                            class="fa fa-heart"
                            :class="{ 'learning-lesson__favorite-icon--active': item2.isFavorite }"
                          />
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </template>
            <template v-else>
              <li class="learning-sidebar__empty">{{ $t('learning.noData') }}</li>
            </template>
          </ul>

          <div class="learning-sidebar__actions">
            <a
              v-if="currentPlay.classLecturePath !== ''"
              class="learning-sidebar__action-btn"
              :href="currentPlay.classLecturePath"
              target="_blank"
            >
              <i class="fa fa-file-text" aria-hidden="true"></i>
              <span>{{ $t('learning.downloadSupplements') }}</span>
            </a>
            <a
              v-else
              class="learning-sidebar__action-btn learning-sidebar__action-btn--disabled"
              @click.prevent="ShowMsgForNotDownloadFile"
            >
              <i class="fa fa-file-text" aria-hidden="true"></i>
              <span>{{ $t('learning.noSupplements') }}</span>
            </a>

            <a
              v-if="currentPlay.classNotePath !== ''"
              class="learning-sidebar__action-btn"
              :href="currentPlay.classNotePath"
              target="_blank"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
              <span>{{ $t('learning.downloadNotes') }}</span>
            </a>
            <a
              v-else
              class="learning-sidebar__action-btn learning-sidebar__action-btn--disabled"
              @click.prevent="ShowMsgForNotDownloadFile"
            >
              <i class="fa fa-download" aria-hidden="true"></i>
              <span>{{ $t('learning.noNotes') }}</span>
            </a>

            <a
              class="learning-sidebar__action-btn"
              @click="handleOpenNode()"
            >
              <i class="fa fa-pencil" aria-hidden="true"></i>
              <span>{{ $t('learning.addNote') }}</span>
            </a>

            <a
              v-if="subject.otherLinkPath"
              class="learning-sidebar__action-btn learning-sidebar__action-btn--exam"
              @click="handleOpenLink(subject.otherLinkPath)"
            >
              <i class="fa fa-flask" aria-hidden="true"></i>
              <span>{{ $t('learning.button.exam') }}</span>
            </a>
          </div>
          </div>
        </div>
      </div>

      <!-- 課程相關資訊 -->
      <div class="learning-page__full-width">
        <CourseInfo
          :courseInfo="data"
          :learning="true"
        />
      </div>

      <Notes
        :showModel.sync="showNote"
        :code="currentPlay.classCode"
        :classItem="currentPlay.className"
        :videoTime="currentTime"
        :course="data.courseName"
        @changeCurrentTime="changeCurrentTime"
        @changeNoteCount="changeNoteCount"
        @pauseVideo="handlePauseVideo"
      />
    </div>
  </section>
</template>

<script>
import Plyr from 'plyr';
import Hls from 'hls.js';
import 'plyr/dist/plyr.css';
import {
  GetBuyCourseContentByMember,
  GetVideoTime,
  SetVideoTime,
  GetVideoCookies,
} from '@/api/BuyCourseApi';
import { AddToFavorite, RemoveToFavorite } from '@/api/MemberRecordApi';

import CourseInfo from '@/components/CourseInfo.vue';
import Notes from '@/components/Learning/Notes.vue';
/* global $ */

export default {
  props: ['currentPage'],
  components: {
    CourseInfo,
    Notes,
  },
  data() {
    // 建立你的初始化 model data
    return {
      // 真實觀看時間相關
      realWatchStartTime: null,
      realWatchSaveTimer: null,

      // 播放器相關
      player: null,
      hasVideo: false,
      hasCaption: false,
      hasError: false,
      currentTime: 0,
      keepTime: 0,

      // UI 狀態相關
      showNote: 0,
      courseType: 1,
      isReedy: false,

      // 當前播放相關
      currentPlay: '',
      subject: {},

      // 字幕相關
      captionsSrc: '',
      cssContent: '',

      // 播放器設定
      videoSource: [
        { src: '_720p.m3u8', size: 720 },
        { src: '_1080.m3u8', size: 1080 },
      ],
      options: {
        clickToPlay: false,
        controls: [
          'play-large', 'rewind', 'play', 'fast-forward', 'progress',
          'current-time', 'duration', 'mute', 'volume', 'settings', 'fullscreen', 'pip',
        ],
        captions: { active: true, language: 'auto', update: true },
        settings: ['quality', 'speed'],
        quality: { default: 720, options: [1080, 720] },
        speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] },
        fullscreen: {
          enabled: true, fallback: true, iosNative: true, container: null,
        },
      },
      // 課程資料
      data: {
        courseId: 0,
        courseName: '',
        examId: 0,
        examName: '',
        categoryId: 0,
        categoryName: '',
        roomId: 0,
        roomName: '',
        courseOriPrice: 0,
        coursePrice: 0,
        courseContent: '',
        contentImagePath: '',
        courseYoutubeUrl: '',
        courseViewStartDate: this.$moment(new Date('9999/12/31')),
        courseViewEndDate: this.$moment(new Date('9999/12/31')),
        classRoomList: [{
          subjectId: 0,
          subjectName: '',
          buyCourseClassRoomList: [{
            classId: 0,
            className: '',
            teacherId: 0,
            teacherName: '',
          }],
        }],
      },
    };
  },
  created() {
    this.cssContent = this.$t('learning.label.viewer');
    this.GetBuyCourseContent();
  },
  mounted() {
    // 設定觀看者帳號在字幕上
    this.initializeCaptions();
  },
  // 組件銷毀時清理
  beforeDestroy() {
    // 離開的時候需要立刻紀錄觀看時間，若有觀看中的話
    if (this.realWatchSaveTimer && this.currentPlay.classCode) {
      this.SetVideoTime(
        this.currentPlay.classCode,
        Math.floor(this.player ? this.player.currentTime : 0),
        'LeavePage',
      );
    }

    this.cleanup();
  },

  beforeRouteLeave(to, form, next) {
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture();
    }

    next();
  },
  computed: {
    courseData() {
      const courseData = this._.reduce(
        this.data.newClassRoomList,
        (result, o) => {
          // 課程分類透過深拷貝，避免因為filter過濾後會影響到原始資料
          // 課程列表內容則不使用深拷貝，這樣才能保持資料同步(當在不同列表的時候，增加/移除我的最愛才可以同步處理)
          const roomLis = { ...o };
          roomLis.buyCourseClassRoomList = this._.filter(o.buyCourseClassRoomList, (i) => {
            if (this.courseType === 1) return true;
            if (i.isFavorite) return true;
            return false;
          });
          if (roomLis.buyCourseClassRoomList.length > 0) result.push(roomLis);
          return result;
        },
        [],
      );

      return courseData;
    },
  },
  methods: {
    // ==================== 初始化和清理 ====================
    // 設定觀看者帳號在字幕上
    initializeCaptions() {
      this.cssContent = window.btoa(unescape(this.$UserId));
      const captionsText = `WEBVTT\n\n00:00:00.000 --> 23:00:00.000\n${this.$UserAccount}`;
      const captionsBase64 = window.btoa(unescape(encodeURIComponent(captionsText)));
      this.captionsSrc = `data:@file/octet-stream;base64,${captionsBase64}`;
    },

    // 清除播放器
    cleanup() {
      this.stopRealWatchTime();

      if (this.isPlayerReady()) {
        this.removePlayerEvents(); // 確保事件被清理
        this.player.destroy();
        this.player = null;
      }

      if (this.isHlsReady()) {
        if (window.hls.media) {
          window.hls.detachMedia();
        }
        window.hls.destroy();
        window.hls = null;
      }

      // 清理特定的播放器控制事件
      $('video').off('click.playerControl');
    },

    // ==================== 資料取得相關 ====================
    // 取得購買課程內容
    GetBuyCourseContent() {
      const { id } = this.$route.params;
      GetBuyCourseContentByMember({ courseId: id }).then((response) => {
        if (response.data.statusCode === 0) {
          try {
            this.data = response.data.data;
            this.$emit('update:currentPage', [
              {
                name: '',
                title: this.data.courseName,
                path: '',
              },
            ]);
            // 取出精選課程
            const classRoomList = this._.cloneDeep(this.data.classRoomList);
            // 取出自選課程
            const optionalClassRoomList = this._.flatMap(
              this._.cloneDeep(this.data.optionalClassRoomList),
              (item) => item.optionalClassRoomList,
            );

            // 已自選課程為主，保留兩邊重複的項目
            const intersection = this._.intersectionWith(
              optionalClassRoomList,
              classRoomList, (a, b) => a.subjectId === b.subjectId && a.teacherId === b.teacherId,
            );

            // 已精選課程為主，去除掉重複項目
            const unionData = this._.unionWith(classRoomList,
              optionalClassRoomList,
              (a, b) => a.subjectId === b.subjectId && a.teacherId === b.teacherId);

            // 將自選課程與精選課程重複的項目，加回去
            this._.forEach(intersection, (item) => {
              const data = this._.find(unionData,
                { subjectId: item.subjectId, teacherId: item.teacherId });
              data.buyCourseClassRoomList = data.buyCourseClassRoomList
                .concat(item.buyCourseClassRoomList);
            });

            // 再重新整理，將重複的classId剔除掉
            this._.forEach(unionData, (item) => {
              // eslint-disable-next-line no-param-reassign
              item.buyCourseClassRoomList = this._.uniqBy(item.buyCourseClassRoomList, 'classId');
            });

            this.$set(this.data, 'newClassRoomList', unionData);

            if (!this._.isEmpty(this.data.newClassRoomList)) {
              const list = this.data.newClassRoomList[0].buyCourseClassRoomList;

              if (!this._.isEmpty(list)) {
                this.subject = this._.cloneDeep(list[0]);
              }
            }

            this.isReedy = true;
          } catch (error) {
            this.$router.replace('/error').catch();
          }
        } else this.$router.replace('/error').catch();
      });
    },

    // 取得影片觀看時間位置
    GetVideoTime(name, showLoading = false) {
      this.keepTime = 0;
      this.currentTime = 0;
      return GetVideoTime({ name }, showLoading).then((response) => {
        if (response.data.statusCode === 0) {
          this.currentTime = Math.floor(response.data.data);
          this.keepTime = this.currentTime;
        }
      });
    },

    // 取得觀看影片的cookies
    GetVideoCookies(name, showLoading = false) {
      const { id } = this.$route.params;
      return GetVideoCookies({ courseId: id, name }, showLoading).then((response) => {
        if (response.data.statusCode === 0) {
          const { data } = response.data;
          document.cookie = `CloudFront-Policy=${data.policy};path=/; max-age=86400;`;
          document.cookie = `CloudFront-Key-Pair-Id=${data.keyPairId};path=/; max-age=86400;`;
          document.cookie = `CloudFront-Signature=${data.signature};path=/; max-age=86400;`;
        }
      });
    },

    // ==================== UI 互動相關 ====================
    // 切換課程
    ToggleClass(event) {
      // 找到最近的 .learning-course 父元素
      const courseElement = event.currentTarget.closest('.learning-course');
      if (courseElement) {
        courseElement.classList.toggle('active');
      }
    },
    // 開啟筆記
    async handleOpenNode(item2 = null) {
      if (
        item2 != null
        && (this.currentPlay.classCode === '' || this.currentPlay.classCode !== item2.classCode)
      ) {
        await this.OpenVideo(item2);
        this.showNote = 1;
      } else {
        this.showNote = 1;
      }
      if (item2 === null) {
        this.showNote = 2;
        this.handlePauseVideo();
      }
    },
    // 我的最愛
    handleFavorite(classInof) {
      if (classInof.hasVideo) {
        const { isFavorite, classCode, className } = classInof;
        const data = classInof;
        let func = AddToFavorite;
        if (isFavorite) {
          func = RemoveToFavorite;
        }
        func({ name: classCode }).then((res) => {
          if (res.data.statusCode === 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: `成功將${className}${isFavorite ? '移除' : '加入'}我的最愛`,
            });

            data.isFavorite = !isFavorite;
          }
        });
      }
    },
    // 變更筆記數量
    changeNoteCount(count) {
      this.currentPlay.videoNotesCount = count;
    },
    // 開啟外部連結
    handleOpenLink(url) {
      window.open(url);
    },

    // ==================== 影片播放相關 ====================
    isPlayerReady() {
      return this.player && this.player !== null;
    },

    isHlsReady() {
      return window.hls && window.hls !== null;
    },
    shouldAutoSave() {
      return this.isPlayerReady()
        && this.player.playing // 檢查播放器狀態
        && !this.player.paused // 檢查是否暫停
        && this.realWatchStartTime;
    },
    // 開始真實觀看時間記錄
    startRealWatchTime() {
      // 確認播放器確實在播放
      if (!this.isPlayerReady() || !this.player.playing || this.player.paused) {
        // console.log('startRealWatchTime 取消 - 播放器未在播放狀態');
        return;
      }

      if (this.realWatchSaveTimer) {
        // console.log('停止舊的計時器');
        this.stopRealWatchTime();
      }

      this.realWatchStartTime = Date.now();
      // console.log('開始計時:', new Date().toLocaleTimeString());

      this.realWatchSaveTimer = setInterval(() => {
        // console.log('定時器檢查:', new Date().toLocaleTimeString());
        if (this.shouldAutoSave()) {
          const watchedSeconds = Math.floor((Date.now() - this.realWatchStartTime) / 1000);
          // console.log('已觀看秒數:', watchedSeconds);
          if (watchedSeconds >= 300) { // 每五分鐘自動儲存一次
            // console.log('準備保存 - 觀看時間:', watchedSeconds, '秒');
            this.SetVideoTime(
              this.currentPlay.classCode,
              Math.floor(this.player.currentTime),
              'AutoSave',
            );
            this.realWatchStartTime = Date.now(); // 重置計時器
            // console.log('重置計時器:', new Date().toLocaleTimeString());
          }
        }
      }, 60000); // 每分鐘檢查一次
    },
    // 停止真實觀看時間記錄
    stopRealWatchTime() {
      // console.log('停止計時:', new Date().toLocaleTimeString(), this.realWatchSaveTimer);
      if (this.realWatchSaveTimer) {
        clearInterval(this.realWatchSaveTimer);
        this.realWatchSaveTimer = null;
      }
    },
    // 重置真實觀看時間
    resetRealWatchTime() {
      this.realWatchStartTime = null;
    },

    // ==================== 播放器事件處理 ====================
    setupPlayerEvents() {
      if (!this.isPlayerReady()) return;

      // 移除所有舊的事件監聽器
      this.removePlayerEvents();

      // 重新設置事件監聽器
      this.player.on('error', this.handleError);
      this.player.on('play', this.handlePlay);
      this.player.on('pause', this.handleSaveVideoTime);
      this.player.on('canplay', this.canplay);
      this.player.on('ended', this.ended);
    },
    removePlayerEvents() {
      if (!this.isPlayerReady()) return;

      this.player.off('error', this.handleError);
      this.player.off('play', this.handlePlay);
      this.player.off('pause', this.handleSaveVideoTime);
      this.player.off('canplay', this.canplay);
      this.player.off('ended', this.ended);
      this.player.off('timeupdate', this.timeupdate);
    },

    // ==================== Plyr 播放器初始化 ====================
    // HLS 初始化部分
    createPlayerWithHls() {
      const video = document.querySelector('video');
      if (!video) return;

      const myStorage = window.localStorage;
      const quality = JSON.parse(myStorage.getItem('plyr') || '{"quality":720}');
      const Level = parseInt(quality.quality, 10) === 720 ? 0 : 1;

      const hls = new Hls({
        startLevel: Level,
        autoStartLoad: false,
        startPosition: this.currentTime,

        debug: false,
        enableWorker: true,
        lowLatencyMode: false,
        // maxLoadingDelay: 4,
        // 保留90秒已播放內容，方便倒退
        backBufferLength: 90,
        // 播放器會預先載入30秒的內容
        maxBufferLength: 30,
        // 60MB = 緩衝區不會超過60MB記憶體
        maxBufferSize: 60 * 1000 * 1000, // 60MB
      });

      // const rootUrl = `https://jozu-bucket-streaming.s3.ap-southeast-1.amazonaws.com/m3u8/${this.currentPlay.classCode}`;
      const rootUrl = `/m3u8/${this.currentPlay.classCode}`;
      hls.loadSource(`${rootUrl}/${this.currentPlay.classCode}.m3u8`);

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        hls.startLoad(this.currentTime);
        this.setupHlsPlayer(hls, video);
      });

      window.hls = hls;
    },
    //  HLS Plyr 初始化邏輯
    setupHlsPlayer(hls, video) {
      const availableQualities = hls.levels.map((l) => l.height);
      const defaultOptions = {
        ...this.options,
        quality: {
          default: 720,
          options: availableQualities,
          forced: true,
          onChange: (e) => this.updateQuality(e),
        },
      };
      // 加入字幕軌-觀看者
      this.addCaptionTrack(video);
      // 建立 Plyr 播放器
      this.player = new Plyr(video, defaultOptions);
      // this.player.currentTime = this.currentTime;

      // 將 HLS.js 附加到 Plyr 的 video 元素
      hls.attachMedia(video);

      // 監聽 loadedmetadata 事件再設置時間
      video.addEventListener('loadedmetadata', () => {
        if (this.currentTime > 0) {
          this.player.currentTime = this.currentTime;
        }
      }, { once: true });

      // 設定事件
      this.setupPlayerEvents();
      // 設定影片點擊播放/暫停
      this.setupVideoClickHandler();
      // 設定跨域請求帶上憑證
      this.player.setXHRWithCredentials(true);
    },
    // HLS 的 Plyr 初始化部分
    createPlayerWithoutHls() {
      const video = document.querySelector('video');
      if (!video) return;
      this.player = new Plyr(video, this.options);

      this.player.source = {
        type: 'video',
        sources: [
          { src: this.videoSource[0].src, size: 720 },
          { src: this.videoSource[1].src, size: 1080 },
        ],
        tracks: [{
          kind: 'captions',
          label: '觀看者',
          srclang: 'zh',
          src: this.captionsSrc,
          default: true,
        }],
      };

      // 設置事件監聽器
      this.setupPlayerEvents();
      // 設定影片點擊播放/暫停
      this.setupVideoClickHandler();

      // 設置品質變更監聽器
      this.player.on('qualitychange', () => {
        this.player.off('timeupdate', this.timeupdate);
        this.player.off('canplay', this.canplay);
        this.player.on('canplay', this.canplay);
      });
    },
    // 建立字幕軌-觀看者
    addCaptionTrack(video) {
      if (!video) return;

      // 移除舊的字幕軌道
      if (this.hasCaption) {
        const existingTrack = document.getElementById('trackZh');
        if (existingTrack) {
          video.removeChild(existingTrack);
        }
      }

      // 創建新的字幕軌道
      const track = document.createElement('track');
      track.id = 'trackZh';
      track.kind = 'captions';
      track.label = this.$t('learning.label.viewer');
      track.srclang = 'zh';
      track.default = true;
      track.src = this.captionsSrc;

      video.appendChild(track);
      this.hasCaption = true;
    },
    // 設定影片點擊播放/暫停
    setupVideoClickHandler() {
      const $video = $('video');

      // 移除之前綁定的播放器控制事件（不會影響其他事件）
      $video.off('click.playerControl');

      // 綁定新的播放器控制事件
      $video.on('click.playerControl', () => {
        if (this.isPlayerReady()) {
          if (this.player.playing) {
            this.player.pause();
          } else {
            this.player.play();
          }
        }
      });
    },
    // 記錄影片觀看時間位置
    SetVideoTime(name, time, action = '') {
      if (time === 0 && action === '') {
        return;
      }

      // 計算真實觀看時間
      const totalSecond = this.realWatchStartTime
        ? Math.floor((Date.now() - this.realWatchStartTime) / 1000)
        : 0;

      // console.log(`SetVideoTime - Action: ${action}`);
      // console.log(`  影片播放位置: ${time}秒`);
      // console.log(`  實際觀看時間: ${totalSecond}秒`);
      // console.log(`  開始計時時間: ${this.realWatchStartTime ?
      //  new Date(this.realWatchStartTime).toLocaleTimeString() : 'null'}`);
      // console.log(`  當前時間: ${new Date().toLocaleTimeString()}`);

      const data = {
        name,
        time,
        action,
        TotalSecond: totalSecond,
        CourseId: this.data.courseId || '',
        ClassId: this.subject.classId || '',
      };
      SetVideoTime(data);
      this.currentPlay.time = Math.floor(time);
    },
    // 開啟影片
    async OpenVideo(item2) {
      // 記錄切換前的觀看時間
      if (this.realWatchStartTime && this.currentPlay.classCode) {
        this.SetVideoTime(
          this.currentPlay.classCode,
          Math.floor(this.player ? this.player.currentTime : 0),
          'SwitchVideo',
        );
      }

      // 停止之前的計時
      this.stopRealWatchTime();
      this.resetRealWatchTime();

      const { hasVideo, classCode } = item2;

      // 統一播放器檢查和清理
      if (this.isPlayerReady()) {
        this.removePlayerEvents(); // 確保事件被清理
        this.player.destroy();
        this.player = null;
      }
      if (this.showNote !== 0) this.showNote = 0;
      this.hasVideo = false;

      if (hasVideo) {
        this.currentPlay = item2;
        await this.GetVideoCookies(classCode, true);
        await this.GetVideoTime(classCode, true);
        this.handleLoadVideo();
      } else {
        this.$message({
          showClose: true,
          type: 'warning',
          message: this.$t('learning.message.videoComingSoon'),
        });
      }
      this.hasVideo = hasVideo;

      this.subject = this._.cloneDeep(item2);
    },
    // 切換影片清晰度
    updateQuality(newQuality) {
      if (window.hls && window.hls.levels) {
        window.hls.levels.forEach((level, levelIndex) => {
          if (level.height === newQuality) {
            window.hls.currentLevel = levelIndex;
          }
        });
      }
    },
    // 影片可以播放
    canplay() {
      if (!this.player) return;

      this.player.currentTime = this.currentTime;

      if (this.player.ended === true) {
        this.ended();
        return;
      }

      if (this.player.currentTime === this.currentTime) {
        this.player.off('canplay', this.canplay);
        this.player.off('timeupdate', this.timeupdate);
        this.player.on('timeupdate', this.timeupdate);
      }

      const video = document.querySelector('video');
      if (document.pictureInPictureElement && video) {
        video.requestPictureInPicture();
      }
    },
    // 影片播放完畢
    ended() {
      // 停止真實觀看時間記錄
      this.stopRealWatchTime();

      // 重置播放狀態
      this.keepTime = 0;
      this.currentTime = 0;

      // 記錄影片播放完畢
      this.SetVideoTime(this.currentPlay.classCode, 0, 'EndVideo');
      this.currentPlay.isLook = true;
      this.resetRealWatchTime();

      // 清理當前播放器
      if (this.isPlayerReady()) {
        this.removePlayerEvents(); // 確保事件被清理
        this.player.destroy();
        this.player = null;
      }

      // 重新初始化播放器（為了重播功能）
      this.reinitializePlayerAfterEnd();
    },
    // 播放結束後重新初始化播放器
    reinitializePlayerAfterEnd() {
      // 重置播放時間為開始位置
      this.currentTime = 0;

      if (Hls.isSupported()) {
        this.createPlayerWithHls();
      } else {
        this.createPlayerWithoutHls();
      }
    },
    // 影片長度時間更新 (撥放器事件)
    timeupdate() {
      if (this.isPlayerReady()) {
        this.currentTime = this.player.currentTime;
      }
    },
    // 顯示沒有提供下載檔案訊息
    ShowMsgForNotDownloadFile() {
      this.$message({
        showClose: true,
        type: 'warning',
        message: this.$t('learning.message.notAvailable', { className: this.currentPlay.className }),
      });
    },
    // 變更影片播放時間
    changeCurrentTime(time) {
      if (this.isPlayerReady()) {
        this.player.currentTime = parseInt(time, 10);
      }
    },
    // 暫停影片
    handlePauseVideo() {
      if (this.isPlayerReady()) {
        this.player.pause();
      }
    },
    // 暫停就記錄
    handleSaveVideoTime() {
      // console.log('handleSaveVideoTime 觸發 - 播放器狀態:', {
      //   playerReady: this.isPlayerReady(),
      //   paused: this.player?.paused,
      //   hasTimer: !!this.realWatchSaveTimer,
      // });

      if (this.isPlayerReady()) {
        // 只有在有計時器的情況下才執行保存邏輯
        if (this.realWatchSaveTimer) {
          this.stopRealWatchTime();

          this.SetVideoTime(
            this.currentPlay.classCode,
            Math.floor(this.player.currentTime),
            'Pause',
          );

          this.keepTime = this.player.currentTime;
          this.currentTime = this.player.currentTime;
          this.resetRealWatchTime();
        } else {
          // console.log('handleSaveVideoTime 跳過 - 沒有活動的計時器');
        }
      }
    },
    // 影片錯誤
    handleError() {
      if (this.isPlayerReady()) {
        this.player.off('timeupdate', this.timeupdate);
      }
      this.hasError = true;
    },
    // 影片播放
    async handlePlay() {
      // console.log('handlePlay 觸發 - 播放器狀態:', {
      //   playing: this.player?.playing,
      //   paused: this.player?.paused,
      //   hasTimer: !!this.realWatchSaveTimer,
      // });

      if (!this.isHlsReady()) {
        await this.GetVideoCookies(this.currentPlay.classCode);

        if (this.hasError) {
          this.hasError = false;
          await this.GetVideoTime(this.currentPlay.classCode);
          this.player.off('canplay', this.canplay);
          this.player.on('canplay', this.canplay);
          const video = document.querySelector('video');
          video.load();
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.hasError) {
          this.hasError = false;
          this.OpenVideo(this.currentPlay);
        } else {
          await this.GetVideoCookies(this.currentPlay.classCode);
          // 檢查 HLS 狀態再啟動
          if (window.hls && !window.hls.media) {
            window.hls.attachMedia(document.querySelector('video'));
          }
          window.hls.startLoad(this.currentTime);
        }
      }

      // // 開始計時真實觀看時間
      // if (!this.realWatchSaveTimer) {
      //   console.log('handlePlay 啟動觀看時間計時器');
      //   this.startRealWatchTime();
      // }

      // 延遲檢查播放狀態，確保播放器狀態已更新
      setTimeout(() => {
        if (this.isPlayerReady() && this.player.playing && !this.player.paused) {
          if (!this.realWatchSaveTimer) {
            // console.log('handlePlay 啟動觀看時間計時器 - 影片確實在播放');
            this.startRealWatchTime();
          } else {
            // console.log('計時器已存在，不重複啟動');
          }
        } else {
          // console.log('handlePlay 不啟動計時器 - 影片未實際播放', {
          //   playerReady: this.isPlayerReady(),
          //   playing: this.player?.playing,
          //   paused: this.player?.paused,
          // });
        }
      }, 100); // 延遲100ms檢查
    },
    // 載入影片
    handleLoadVideo() {
      if (this.showNote !== 0) this.showNote = 0;
      // const rootUrl = `https://jozu-bucket-streaming.s3.ap-southeast-1.amazonaws.com/m3u8/${this.currentPlay.classCode}`;
      const rootUrl = `/m3u8/${this.currentPlay.classCode}`;
      this.videoSource[0].src = `${rootUrl}/${this.currentPlay.classCode}_720.m3u8`;
      this.videoSource[1].src = `${rootUrl}/${this.currentPlay.classCode}_1080.m3u8`;

      this.cleanup();

      // 重置錯誤狀態
      this.hasError = false;

      if (Hls.isSupported()) {
        this.createPlayerWithHls();
      } else {
        this.createPlayerWithoutHls();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

// ==================== 主容器 ====================
.learning-page {
  &__container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    margin-bottom: 16px;

    @media (min-width: $breakpoint-sm) {
      gap: 20px;
    }

    @media (min-width: $breakpoint-md) {
      grid-template-columns: 1fr 360px;
      gap: 24px;
    }
  }

  &__video-wrapper {
    grid-column: 1;

    @media (min-width: $breakpoint-md) {
      grid-row: 1;
    }
  }

  &__sidebar {
    grid-column: 1;

    @media (min-width: $breakpoint-md) {
      grid-column: 2;
      grid-row: 1 / 3;
    }
  }

  &__full-width {
    grid-column: 1 / -1;
  }

  &__notice {
    margin-top: 12px;
    padding: 16px 20px;
    background-color: var(--info-light-color, #F4F4F5);
    border-radius: 8px;
    text-align: center;
  }

  &__notice-text {
    margin: 0;
    font-size: 14px;
    color: var(--text-regular);

    a {
      color: var(--primary-color);
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

// ==================== 視頻區域 ====================
.learning-video {
  margin-bottom: 0;

  &__player {
    position: relative;
    width: 100%;
    background-color: #000;
    border-radius: 6px;
    overflow: hidden;

    @media (min-width: $breakpoint-sm) {
      border-radius: 8px;
    }

    @media (min-width: $breakpoint-md) {
      border-radius: 12px;
    }
  }

  &__container {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%; // 16:9 aspect ratio
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  &__iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

}

// ==================== 側邊欄 ====================
.learning-sidebar {
  background-color: var(--background-white);
  border-radius: 8px;
  border: 1px solid var(--border-color-light, #EBEEF5);
  overflow: hidden;

  &__header {
    padding: 16px 20px;
    background-color: var(--background-base, #F5F7FA);
    border-bottom: 1px solid var(--border-color-light, #EBEEF5);
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
  }

  &__tabs {
    display: flex;
    gap: 0;
    border-bottom: 1px solid var(--border-color-light, #EBEEF5);
  }

  &__tab {
    flex: 1;
    padding: 12px 8px;
    background-color: var(--background-white);
    border: none;
    border-bottom: 2px solid transparent;
    color: var(--text-regular);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;

    i {
      flex-shrink: 0;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover {
      color: var(--primary-color);
      background-color: var(--primary-light-color, #dcf1fa);
    }

    &--active {
      background-color: var(--primary-color);
      color: var(--background-white);
      border-bottom-color: var(--primary-color);

      &:hover {
        background-color: var(--primary-color);
        color: var(--background-white);
      }
    }

    @media (max-width: 360px) {
      padding: 12px 6px;
      font-size: 13px;
      gap: 4px;
    }
  }

  &__list {
    max-height: 245px;
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &__empty {
    padding: 40px 20px;
    text-align: center;
    color: var(--text-secondary);
    font-size: 14px;
  }

  &__actions {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    border-top: 1px solid var(--border-color-light, #EBEEF5);

    @media (max-width: $breakpoint-sm) {
      grid-template-columns: repeat(3, 1fr);
      grid-auto-flow: dense;
    }
  }

  &__action-btn {
    padding: 10px 8px;
    background-color: var(--background-white);
    border: none;
    border-right: 1px solid var(--border-color-light, #EBEEF5);
    color: var(--primary-color);
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-height: 60px;

    i {
      font-size: 18px;
      flex-shrink: 0;
    }

    span {
      line-height: 1.2;
      word-break: keep-all;
      overflow-wrap: break-word;
      hyphens: auto;
    }

    &:last-child {
      border-right: none;
    }

    &:hover {
      background-color: var(--primary-light-color, #dcf1fa);
      color: var(--primary-color);
    }

    &--disabled {
      color: var(--text-secondary);
      cursor: not-allowed;

      &:hover {
        background-color: var(--background-white);
        color: var(--text-secondary);
      }
    }

    &--exam {
      grid-column: 1 / -1;
      flex-direction: row;
      gap: 8px;
      background-color: var(--primary-darken-color);
      color: var(--background-white);
      border-top: 1px solid var(--border-color-light, #EBEEF5);
      padding: 14px 16px;
      min-height: auto;

      i {
        font-size: 16px;
      }

      span {
        font-size: 14px;
      }

      &:hover {
        background-color: var(--primary-hover-color, #0099d8);
        color: var(--background-white);
      }

      @media (max-width: $breakpoint-sm) {
        padding: 12px 14px;
        font-size: 13px;

        i {
          font-size: 14px;
        }

        span {
          font-size: 13px;
        }
      }
    }

    @media (max-width: 360px) {
      font-size: 12px;
      padding: 8px 6px;

      i {
        font-size: 16px;
      }
    }
  }
}

// ==================== 課程組 ====================
.learning-course {
  border-bottom: 1px solid var(--border-color-light, #EBEEF5);

  &:last-child {
    border-bottom: none;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background-color: var(--background-white);
    cursor: pointer;
    transition: all 0.3s ease;
    user-select: none;

    &:hover {
      background-color: var(--background-base, #F5F7FA);
    }

    @media (max-width: $breakpoint-md) {
      padding: 12px 16px;
    }
  }

  &__header-info {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);

    i {
      color: var(--primary-color);
      font-size: 16px;
      flex-shrink: 0;
    }

    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    @media (max-width: $breakpoint-md) {
      font-size: 14px;
      gap: 8px;

      i {
        font-size: 14px;
      }
    }
  }

  &__header-title {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 4px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__header-subtitle {
    font-size: 13px;
    color: var(--text-secondary);
    margin: 0;
  }

  &__header-count {
    font-size: 13px;
    font-weight: 500;
    color: var(--text-secondary);
    margin: 0 12px 0 0;
    flex-shrink: 0;
    background-color: var(--background-base, #F5F7FA);
    padding: 4px 10px;
    border-radius: 12px;

    @media (max-width: $breakpoint-md) {
      font-size: 12px;
      padding: 3px 8px;
      margin: 0 8px 0 0;
    }
  }

  &__header-toggle {
    color: var(--text-secondary);
    font-size: 16px;
    transition: transform 0.3s ease, color 0.3s ease;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    i {
      transition: transform 0.3s ease;
    }

    .learning-course.active & {
      color: var(--primary-color);

      i {
        transform: rotate(180deg);
      }
    }

    @media (max-width: $breakpoint-md) {
      font-size: 14px;
      width: 20px;
      height: 20px;
    }
  }

  &__lessons {
    display: none;
    background-color: var(--background-base, #F5F7FA);
    list-style: none;
    padding: 0;
    margin: 0;

    .learning-course.active & {
      display: block;
    }
  }
}

// ==================== 課程項目 ====================
.learning-lesson {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 20px 14px 44px;
  border-bottom: 1px solid var(--border-color-lighter, #F2F6FC);
  transition: all 0.3s ease;
  background-color: var(--background-white);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--primary-light-color, #dcf1fa);
  }

  &--playing {
    background-color: var(--primary-light-color, #dcf1fa);
    border-left: 4px solid var(--primary-color);
    padding-left: 40px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: linear-gradient(180deg, var(--primary-color) 0%, var(--primary-light-color) 100%);
    }
  }

  &--coming-soon {
    opacity: 0.6;

    &:hover {
      background-color: var(--background-base, #F5F7FA);
    }
  }

  &__play-icon {
    position: absolute;
    left: 20px;
    top: 18px;
    color: var(--primary-color);
    font-size: 18px;
    animation: pulse 2s ease-in-out infinite;

    .learning-lesson--playing & {
      left: 16px;
    }
  }

  &__link {
    font-size: 14px;
    line-height: 1.5;
    color: var(--text-primary);
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease;
    word-break: break-word;

    &:hover {
      color: var(--primary-color);
    }

    .learning-lesson--playing & {
      color: var(--primary-color);
      font-weight: 600;
    }

    .learning-lesson--coming-soon & {
      color: var(--text-secondary);
      cursor: not-allowed;
    }
  }

  &__info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
  }

  &__status-icon {
    display: flex;
    align-items: center;

    i {
      font-size: 15px;
      color: var(--text-secondary);
      transition: color 0.3s ease;

      &.learning-lesson__status-icon--completed {
        color: var(--success-color, #67C23A);
      }
    }
  }

  &__time {
    color: var(--text-secondary);
    display: flex;
    align-items: flex-start;
    gap: 4px;

    &--disabled {
      opacity: 0.6;
    }
  }

  &__notes {
    margin-left: auto;

    &-link {
      color: var(--text-secondary);
      text-decoration: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 4px;
      transition: color 0.3s ease;

      &:hover {
        color: var(--primary-color);
      }

      &--disabled {
        opacity: 0.6;
        cursor: not-allowed;

        &:hover {
          color: var(--text-secondary);
        }
      }
    }
  }

  &__favorite {
    &-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      text-decoration: none;
      cursor: pointer;
      padding: 4px;
      border-radius: 50%;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: rgba(230, 162, 60, 0.1);
      }

      i {
        font-size: 15px;
        color: var(--text-secondary);
        transition: all 0.3s ease;

        &:hover {
          color: var(--warning-color, #E6A23C);
          transform: scale(1.1);
        }

        &.learning-lesson__favorite-icon--active {
          color: var(--warning-color, #E6A23C);
        }
      }
    }
  }

  @media (max-width: $breakpoint-md) {
    padding: 12px 16px 12px 40px;

    &--playing {
      padding-left: 36px;
    }

    &__play-icon {
      left: 16px;
      top: 16px;
      font-size: 16px;

      .learning-lesson--playing & {
        left: 12px;
      }
    }

    &__link {
      font-size: 13px;
    }

    &__info {
      font-size: 11px;
      gap: 12px;
    }
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

// ==================== 響應式設計 ====================

// 平板以下 (≤992px)
@media (max-width: $breakpoint-md) {
  .learning-sidebar {
    &__list {
      max-height: 500px;
    }
  }
}

// 手機和小平板 (≤768px)
@media (max-width: $breakpoint-sm) {
  .learning-sidebar {
    border-radius: 6px;

    &__header {
      padding: 14px 16px;
    }

    &__title {
      font-size: 15px;
    }

    &__tab {
      padding: 11px 8px;
      font-size: 13px;

      i {
        font-size: 14px;
      }
    }

    &__actions {
      // 手機版保持水平3列排列
      grid-template-columns: repeat(3, 1fr);
    }

    &__action-btn {
      padding: 9px 6px;
      font-size: 12px;
      min-height: 56px;
      border-right: 1px solid var(--border-color-light, #EBEEF5);
      border-bottom: none;

      i {
        font-size: 16px;
      }

      span {
        font-size: 11px;
        line-height: 1.3;
      }

      // 每行最後一個移除右邊框
      &:nth-child(3n) {
        border-right: none;
      }

      &--exam {
        grid-column: 1 / -1;
        border-right: none;
        border-top: 1px solid var(--border-color-light, #EBEEF5);
      }
    }

    &__list {
      max-height: 450px;
    }
  }

  .learning-course {
    &__header {
      padding: 12px 16px;
    }

    &__header-info {
      font-size: 14px;
      gap: 8px;

      i {
        font-size: 14px;
      }
    }

    &__header-count {
      font-size: 12px;
      padding: 3px 8px;
    }

    &__header-toggle {
      font-size: 14px;
      width: 22px;
      height: 22px;
    }
  }

  .learning-lesson {
    padding: 12px 16px 12px 38px;

    &--playing {
      padding-left: 34px;
    }

    &__play-icon {
      left: 16px;
      top: 16px;
      font-size: 16px;

      .learning-lesson--playing & {
        left: 12px;
      }
    }

    &__link {
      font-size: 13px;
    }

    &__info {
      font-size: 11px;
      gap: 12px;
    }
  }
}

// 小手機 (≤480px)
@media (max-width: $breakpoint-xs) {
  .learning-sidebar {
    &__header {
      padding: 12px 14px;
    }

    &__title {
      font-size: 14px;
    }

    &__tab {
      padding: 10px 6px;
      font-size: 12px;
      gap: 4px;

      i {
        font-size: 13px;
      }
    }

    &__actions {
      // 小手機仍保持3列,但縮小尺寸
      grid-template-columns: repeat(3, 1fr);
    }

    &__action-btn {
      padding: 8px 4px;
      font-size: 11px;
      min-height: 52px;

      i {
        font-size: 14px;
      }

      span {
        font-size: 10px;
      }

      &--exam {
        padding: 11px 12px;
        font-size: 12px;

        i {
          font-size: 13px;
        }

        span {
          font-size: 12px;
        }
      }
    }

    &__list {
      max-height: 400px;
    }
  }

  .learning-course {
    &__header {
      padding: 10px 14px;
    }

    &__header-info {
      font-size: 13px;
      gap: 6px;

      i {
        font-size: 13px;
      }
    }

    &__header-count {
      font-size: 11px;
      padding: 2px 6px;
      margin: 0 6px 0 0;
    }
  }

  .learning-lesson {
    padding: 10px 14px 10px 36px;
    gap: 8px;

    &--playing {
      padding-left: 32px;
      border-left-width: 3px;
    }

    &__play-icon {
      left: 14px;
      top: 14px;
      font-size: 14px;

      .learning-lesson--playing & {
        left: 10px;
      }
    }

    &__link {
      font-size: 12px;
      line-height: 1.4;
    }

    &__info {
      font-size: 10px;
      gap: 10px;
    }

    &__status-icon i {
      font-size: 13px;
    }

    &__favorite-btn i {
      font-size: 13px;
    }
  }
}

// 超小手機 (≤360px)
@media (max-width: 360px) {
  .learning-sidebar {
    &__header {
      padding: 10px 12px;
    }

    &__title {
      font-size: 13px;
    }

    &__tab {
      font-size: 11px;
      padding: 9px 4px;
      gap: 3px;

      i {
        font-size: 12px;
      }
    }

    &__action-btn {
      padding: 7px 3px;
      font-size: 10px;
      min-height: 50px;

      i {
        font-size: 13px;
      }

      span {
        font-size: 9px;
      }

      &--exam {
        padding: 10px 10px;
        font-size: 11px;

        i {
          font-size: 12px;
        }

        span {
          font-size: 11px;
        }
      }
    }
  }

  .learning-course {
    &__header {
      padding: 9px 12px;
    }

    &__header-info {
      font-size: 12px;
      gap: 5px;

      i {
        font-size: 12px;
      }
    }

    &__header-count {
      font-size: 10px;
      padding: 2px 5px;
    }
  }

  .learning-lesson {
    padding: 8px 12px 8px 32px;

    &--playing {
      padding-left: 28px;
    }

    &__play-icon {
      left: 12px;
      font-size: 13px;

      .learning-lesson--playing & {
        left: 8px;
      }
    }

    &__link {
      font-size: 11px;
    }

    &__info {
      font-size: 10px;
      gap: 8px;
    }
  }
}

// ==================== Plyr 播放器樣式 ====================
::v-deep html {
  --plyr-color-main: var(--primary-color, #00ABEB);
}

::v-deep video {
  height: 100% !important;
  width: 100% !important;
}

::v-deep .plyr {
  height: 100% !important;
  width: 100% !important;
}

::v-deep div[role='menu'] {
  max-height: 100px;
  overflow-x: auto;
}

::v-deep .plyr__video-wrapper::before {
  position: absolute;
  color: #ffffff;
  top: 50%;
  left: 3%;
  z-index: 10;
  pointer-events: none;
  content: var(--content);
  height: 100%;
  width: 93%;
  opacity: 0.1;
  font-size: 90%;
}

::v-deep .plyr__caption {
  opacity: 0.2;
  background: none;
}

::v-deep .plyr__captions {
  top: 0;
  text-align: left;
  pointer-events: none;
  transform: none !important;
}

// ==================== 狀態標記 ====================
.playing {
  position: absolute;
  top: 13px;
  left: 10px;
  padding: 4px 8px;
  background-color: var(--primary-color);
  color: var(--background-white);
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  z-index: 10;
}
</style>
